import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _05_WILD_ANIMAL_FOOD:Partial<EcosystemServiceModel> ={
  id:'wild-animal-food',
  pos:5,
  image: "/images/ecoservices/wild_animal_food.jpg",
  code: ["1.1.6.1"],
  unit:'wild animal food',
  assetType:'species',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "kg",
      element: "animals for food",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
